/* eslint-disable no-unused-vars */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { AuthApi } from '../../../services/modules/auth';
import { useState } from 'react';

export const ReloginForm = ({
  show,
  close,
  reloginType,
}: {
  show: boolean;
  close: () => void;
  reloginType: 'behaviour_change' | 'rebot';
}) => {
  const currentUser = localStorage.getItem('username');

  const [username, setUsername] = useState(currentUser);

  const [password, setPassword] = useState('');
  const onCancelHandle = () => {
    AuthApi.confirmUserAccess({
      username: '',
      password: '',
      cancel: 'true',
      action: reloginType,
    });
    close();
  };

  const onExitHandle = () => {
    AuthApi.confirmUserAccess({
      username: username || '',
      password: password,
      cancel: 'false',
      action: reloginType,
    });
    close();
  };

  return (
    <Dialog
      header={
        reloginType === 'rebot'
          ? 'Выполнить перезагрузку АРМ «Ресурс»?'
          : 'Выход из АРМ «Ресурс»'
      }
      visible={show}
      onHide={onCancelHandle}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <InputText
            placeholder="Имя пользователя"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            type="text"
          />
          <InputText
            placeholder="Пароль"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <Button onClick={onExitHandle} autoFocus label="Ок" />
          <Button
            onClick={onCancelHandle}
            severity="secondary"
            label="Отмена"
          />
        </div>
      </div>
    </Dialog>
  );
};
